import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import { CompanyProvider } from './contexts/CompanyContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Layout from './components/layout/Layout';
import Customers from './pages/Customers';
import Dashboard from './pages/Dashboard';
import Maintenance from './pages/Maintenance';
import Inventory from './pages/Inventory';
import Sales from './components/sales/Sales';
import Shop from './pages/Shop';
import Settings from './pages/Settings';
import UsersManagement from './pages/UsersManagement';
import Login from './pages/Login';
import MaintenanceTracking from './pages/MaintenanceTracking';
import Accounting from './pages/Accounting';
import Rental from './pages/Rental';
import AiChatPage from './pages/AiChatPage';
import LandingPage from './pages/LandingPage';
import PricingPage from './pages/PricingPage';
import PrivateRoute from './components/auth/PrivateRoute';
import './App.css';

function App() {
  return (
    <CompanyProvider>
      <AuthProvider>
        <ThemeProvider>
          <CssBaseline />
          <Router>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/track-maintenance" element={<MaintenanceTracking />} />
              
              {/* Rotte protette */}
              <Route path="/dashboard" element={<PrivateRoute><Layout /></PrivateRoute>}>
                <Route index element={<Dashboard />} />
                <Route path="customers" element={<Customers />} />
                <Route path="maintenance" element={<Maintenance />} />
                <Route path="inventory" element={<Inventory />} />
                <Route path="sales" element={<PrivateRoute><Sales /></PrivateRoute>} />
                <Route path="shop" element={<Shop />} />
                <Route path="users" element={<UsersManagement />} />
                <Route path="settings" element={<Settings />} />
                <Route path="accounting" element={<Accounting />} />
                <Route path="rental" element={<Rental />} />
                <Route path="ai-chat" element={<AiChatPage />} />
              </Route>
            </Routes>
          </Router>
        </ThemeProvider>
      </AuthProvider>
    </CompanyProvider>
  );
}

export default App;
